export default __webpack_public_path__ + "static/media/P6000.1aeb72ec.jpg";